import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import { cashPayoutValidation } from "../../utils/validation";
import * as api from "../../redux/api";
import { toast } from "react-toastify";
import { isYupError, parseYupError } from "../../utils/Yup";
const initialState = {
  amount: "",
};

const CashPayoutModal = ({ handleClose, open, userData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState(initialState);
  const handleCloseModal = () => {
    handleClose();
    setForm(initialState);
    setFormError({});
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
    setFormError({
      ...formError,
      [name]: "",
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      setFormError({});
      await cashPayoutValidation.validate(form, {
        abortEarly: false,
      });
      const res = await api.cashPayout({ ...form, userId: userData });
      if (res.status === 200 || res.status === 201) {
        setIsLoading(false);
        toast.success("Success");
        handleCloseModal();
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      if (isYupError(error)) {
        setFormError(parseYupError(error));
        setIsLoading(false);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        console.log(error, "error");
        toast.error(error.message);
        setIsLoading(false);
      }

      setIsLoading(false);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseModal}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {" "}
          <h4 className=" text-center">Cash Payout</h4>
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <div>
            <div className="max-w-4xl ">
              <div className="w-full   mt-4">
                <div>
                  <div className="input_field  relative">
                    <input
                      type="number"
                      placeholder="Enter Amount"
                      name="amount"
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      min="0"
                    />
                  </div>
                  {formError.amount && (
                    <div className="form-eror">{formError.amount}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            onClick={handleCloseModal}
            className={`btn btn-danger `}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={isLoading}
            className={`btn btn-primary ${
              isLoading
                ? "bg-red-500 border-red-500 opacity-50 disabled:pointer-events-none"
                : undefined
            }`}
          >
            {isLoading ? "Loading" : "Confirm"}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CashPayoutModal;
